"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackORLeCommerceNoResults = exports.trackORLeCommerce = exports.getECommerceTravelType = exports.getECommerceAirline = exports.getECommerceDestination = exports.ECommerceEventType = void 0;
const libs_tracking_events_1 = require("@hotelplan/libs.tracking-events");
const platform_graphql_api_1 = require("@hotelplan/platform-graphql-api");
var ECommerceEventType;
(function (ECommerceEventType) {
    ECommerceEventType["VIEW_ITEM"] = "view_item";
    ECommerceEventType["ADD_TO_CARD"] = "add_to_cart";
})(ECommerceEventType || (exports.ECommerceEventType = ECommerceEventType = {}));
const defaultPaxValues = {
    counts_adults: 0,
    counts_children: 0,
    counts_total: 0,
};
const getECommerceDestination = (waitingScreenImage) => {
    const url = new URL(waitingScreenImage);
    return url.searchParams.get('Destination');
};
exports.getECommerceDestination = getECommerceDestination;
const getECommerceAirline = (outboundFlight, inboundFlight) => {
    if (outboundFlight && inboundFlight) {
        const outboundAirline = outboundFlight.segments[0].airline.iata;
        const inboundAirline = inboundFlight.segments[0].airline.iata;
        return outboundAirline === inboundAirline
            ? outboundAirline
            : `${outboundAirline}-${inboundAirline}`;
    }
    if (outboundFlight) {
        return outboundFlight.segments[0].airline.iata;
    }
    return '';
};
exports.getECommerceAirline = getECommerceAirline;
const getGiataId = (value) => value.match(/\d+/g)[0];
const getECommerceTravelType = (value) => value.charAt(0) + value.slice(1).toLowerCase();
exports.getECommerceTravelType = getECommerceTravelType;
const mapRoomsToItemPax = (rooms) => rooms.reduce((acc, room) => {
    return {
        counts_adults: acc.counts_adults + room.adults || 0,
        counts_children: acc.counts_children + room.children || 0,
        counts_total: acc.counts_total + room.adults + room.children,
    };
}, defaultPaxValues);
const trackORLeCommerce = ({ offer, id, language, productName, eventType, }) => {
    var _a;
    const giataId = getGiataId(id);
    const travelType = (0, exports.getECommerceTravelType)(offer.travelType);
    const destination = (0, exports.getECommerceDestination)(offer.waitingScreenImage);
    const airline = (0, exports.getECommerceAirline)(offer.outboundFlight, offer.inboundFlight);
    const departure = ((_a = offer.outboundFlight) === null || _a === void 0 ? void 0 : _a.departure.iata) || '';
    const itemId = `${platform_graphql_api_1.TravelType.Package === offer.travelType ? 'PK' : 'HO'}${giataId ? '-' + giataId : ''}${departure ? '-' + departure : ''}-${destination}${airline ? '-' + airline : ''}`;
    (0, libs_tracking_events_1.track)({ ecommerce: null });
    (0, libs_tracking_events_1.track)({
        event: eventType,
        ecommerce: {
            currency: offer.totalPrice.currency,
            value: +offer.totalPrice.amount,
            items: [
                {
                    item_id: itemId,
                    item_name: `${travelType}: ${giataId}`,
                    item_destination: destination,
                    item_category: travelType,
                    item_hotel_name: productName,
                    item_airline_name: airline,
                    item_pax: mapRoomsToItemPax(offer.rooms),
                    item_rooms: offer.rooms.length,
                    item_travel_duration: offer.duration.toString(),
                    price: +offer.totalPrice.amount,
                    quantity: 1,
                },
            ],
        },
        language,
        _clear: true,
    });
};
exports.trackORLeCommerce = trackORLeCommerce;
const trackORLeCommerceNoResults = ({ id, language, productName, searchControlTravelType, rooms, }) => {
    const giataId = getGiataId(id);
    const travelType = (0, exports.getECommerceTravelType)(searchControlTravelType);
    (0, libs_tracking_events_1.track)({ ecommerce: null });
    (0, libs_tracking_events_1.track)({
        event: ECommerceEventType.VIEW_ITEM,
        ecommerce: {
            currency: '',
            value: 0,
            items: [
                {
                    item_id: '',
                    item_name: `${travelType}: ${giataId}`,
                    item_destination: '',
                    item_category: travelType,
                    item_hotel_name: productName,
                    item_airline_name: '',
                    item_pax: {
                        counts_adults: rooms.adults,
                        counts_children: rooms.childrenDobs.length,
                        counts_total: rooms.adults + rooms.childrenDobs.length,
                    },
                    item_rooms: rooms.rooms,
                    item_travel_duration: '',
                    price: 0,
                    quantity: 0,
                },
            ],
        },
        language,
        _clear: true,
    });
};
exports.trackORLeCommerceNoResults = trackORLeCommerceNoResults;
//# sourceMappingURL=trackORLeCommerce.js.map